import styled from 'styled-components';

export const ComponentWrapper = styled.div`
  overflow: hidden;
`;
export const FilterHeaderWrapper = styled.div`
  padding-left:  var(--cl-space-5);
  padding-top: var(--cl-space-6);
`;
export const FilterWrapper = styled.div`
  padding-left: var(--cl-space-5);
`;
export const StyledTableDiv = styled.div`
  &&& {
    margin-left: var(--cl-space-10);
    margin-bottom: 4.438rem;
    width: calc(100% - 3.438rem);
    margin-right: var(--cl-space-6);
  }
`;

export const TableWrapper = styled.div`
  min-height: 200px;
  max-height: 800px;
  overflow: auto;
  position: relative;
  &::-webkit-scrollbar {
    -webkit-appearance: none;
  }
  &::-webkit-scrollbar:horizontal {
    height: 7px;
    border-top: 1px solid #d9d9d9;
    border-bottom: 1px solid #d9d9d9;
  }
  &::-webkit-scrollbar:vertical {
    width: 7px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #d9d9d9;
    border-radius: 7px;
    width: 100px;
  }
  &:after {
    content: '';
    display: block;
    position: sticky;
    bottom: 0;
    left: 0;
    height: 48px;
    width: 100%;
    background-image: linear-gradient(to bottom,rgba(255,255,255,0),#ffffff 99%);
    z-index: 0;
  }
`;


const setPickerTopPosition = view => {
  switch (view) {
    case 'caseDetail':
      return '50px;';
    case 'entity':
      return '27px;';
    case 'evaluation':
      return '28px;';
    default:
      return '27px;';
  }
};

export const ColumnPickerWrapper = styled.div`
  position: sticky;
  background: ${
  props => {
    if (props.showGradient) {
      return 'linear-gradient(to right, rgba(255, 255, 255, 0), #ffffff 35%);';
    }
    return 'linear-gradient(to right, rgba(255, 0, 0, 0), rgba(255, 0, 0, 0));';
  }
}
  width: 4.688rem;
  height: var(--cl-space-6);
  left: calc(100% - 4.688rem);
  z-index: 2;
  top: ${props => setPickerTopPosition(props.view)}
  padding-top: 0.188rem;
`;

export const StyledTableHeader = styled.thead`
  margin-bottom: var(--cl-space-4);
  padding-bottom: var(--cl-space-4);
`;

export const StyledTableHead = styled.th`
  &&&& {
    padding-bottom: var(--cl-space-4);
  }
`;

export const StyledCSVWrapper = styled.div`
  cursor: pointer;
  position: relative;
  right: var(--cl-space-4);
  top: var(--cl-space-4);
`;

